import { get, groupBy, mapValues } from 'lodash'

const ingredientAlternativeIngredientsDetailsFormInitialValues =
  alternativeIngredients => {
    const alternativeIngredientsGroupedByDietId = groupBy(
      alternativeIngredients,
      'dietId',
    )

    return {
      alternativeIngredients: mapValues(
        alternativeIngredientsGroupedByDietId,
        ingredients => get(ingredients, `[0].alternativeIngredientId`),
      ),
    }
  }

export default ingredientAlternativeIngredientsDetailsFormInitialValues
